import React, { useState } from 'react';
import { Box, Button, Text, Flex } from '@chakra-ui/react';
const InactivityNotification = ({
    inactivityModalTextColor,
    inactivityModalBackgroundColor,
    inactivityModalBorderRadius,
    inactivityModalPadding,
    inactivityModalTitleColor,
    inactivityModalTitleSize,
    inactivityModalTextSize,
    inactivityModalButtonColor,
    inactivityModalButtonTextColor,
    inactivityModalButtonTextSize,
  }) => {

  return (
      <Box
      bg={inactivityModalBackgroundColor}
      p={inactivityModalPadding}
      borderRadius={inactivityModalBorderRadius}
      boxShadow="lg"
      width="100%"
      maxWidth="500px"
      mx="auto"
      mt={10}
      >
        <Flex direction="column" align="center">
          {/* Header Text */}
          <Text fontSize={inactivityModalTitleSize} fontWeight="bold" color={inactivityModalTitleColor} textAlign="center">
            Inactivity Detected
          </Text>

          {/* Description Text */}
          <Text fontSize={inactivityModalTextSize} color={inactivityModalTextColor} textAlign="center" mt={3}>
            You have been inactive for a while.
          </Text>

          <Text fontSize={inactivityModalTextSize} color={inactivityModalTextColor} textAlign="center" mt={2}>
            Returning to the page will refresh your session.
          </Text>

          {/* Stay on Page Button */}
          <Button
            backgroundColor={inactivityModalButtonColor}
            color={inactivityModalButtonTextColor}

            size="md"
            fontSize={inactivityModalButtonTextSize}
            mt={5}
            px={8}
          >
            Stay on Page
          </Button>
        </Flex>
      </Box>
  );
};

export default InactivityNotification;
